import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Home } from "./components/home";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Prestations } from "./components/prestations";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Footer } from "./components/footer";
import { Prestation } from "./components/prestation";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      {/* <Navigation />
      <Header data={landingPageData.Header} /> */}
      <Router>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home data={landingPageData.Header} />} />
          <Route
            path="/about"
            element={<About data={landingPageData.About} />}
          />
          <Route
            path="/prestation"
            element={<Prestation data={landingPageData.Prestations} />}
          />
          <Route
            path="/features"
            element={<Features data={landingPageData.Features} />}
          />
          <Route
            path="/services"
            element={<Services data={landingPageData.Services} />}
          />
          <Route
            path="/prestations"
            element={<Prestations data={landingPageData.Prestations} />}
          />
          <Route path="/team" element={<Team data={landingPageData.Team} />} />
          <Route
            path="/contact"
            element={<Contact data={landingPageData.Contact} />}
          />
          {/* Ajoute une route pour la page d'accueil */}
        </Routes>
        <Footer/>
      </Router>
      {/* <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <prestations data={landingPageData.prestations} />
      <Team data={landingPageData.Team} />
      <Contact data={landingPageData.Contact} /> */}
    </div>
  );
};

export default App;
